export const LABELS = {
    /**Titles */
    ScriptManagmentTitle: "Deployment Script Management",
    Contract:"Contracts",
    CloudEnviroment:"Cloud Environment",
    DecommissionManagment:"Decommission Management",
    CloudManagment:"Cloud Management",
    CloudEnviromentManagment:"Cloud Environment Management",
    ScriptManagmentTitleTabs: "script management tabs",
    DeploymentScriptIDTitle: "DeploymentScriptID",
    ActiveScripts: "Active Scripts",
    InactiveScripts: "Inactive Scripts",
    ConfigFiles:"Config File",
    AddConfig:"Add Config File",
    ConfigFilesList:"Config File List",
    Provider: "Provider",
    Title: "Title",
    Script: "Script",
    Location: "Location",
    DateAdded: "Date Added",
    ProvisioningDate:"Provisioning Date",
    DecommisioningDate:"Decommissioning Date",
    Notes: "Notes",
    Actions: "Actions",
    NoData:"No data Available",
    Nº: "Nº",
    DeploymentScriptID: "deploymentScriptID",
    DeploymentScript:" Deployment Scripts",
    CloudProvider: "cloudProvider",
    ContractID:"Contract",
    Id: "id",
    ASC: "asc",
    Desc: "desc",
    ArrowUp: "▲",
    ArrowDown: "▼",
    NoScriptAvailable: "scripts available.",
    NO: "NO",
    Active: "Active",
    Inactive: "Inactive",
    Add: "Add",
    AddCloud:"Add Cloud",
    Status: "Status",
    Description: "Description",
    DatacenterScription:"Datacenter Description",
    EditScript: "Edit Script",
    AddScript: "Add Script",
    AddProvider: "Add Provider",
    AddCloudEnviroment: "Add Cloud Environment",
    Update: "Update",
    Save: "Save",
    Submit:"Submit",
    DragDropFileHereOrClickHere: "Drag and drop a file here,",
    OrClickHere:"or click to select file",
    DropFileHere: "Drop the files here ...",
    LogOut: "Logout",
    Profile: "Profile",
    Confirm: "Confirm",
    Cancel: "Cancel",
    Label: "label",
    Settings: "Settings",
    Sim:"sim",
    Nao:"Não",
    DetailView:"Detail View",
    Search:"Search",
    Filters:"Filters",
    ClearAll:"Clear ALL",
    ScriptIdDonotExist:"Script item ID does not exist",
    TitleDecommission:"Decommission Process.",
    Decommision:"Decommission",
    ResourcesDecommission:"Resources for Decommissioning",
    /*Required*/
    ScriptRequired:"Script"
}